import { assertEvent, assign } from 'xstate5';

import { getActiveLocation, getSearchAreaBasedOnCurrentPosition } from '../../../actions';
import { type LocationGroups, type LocationSearchMachineAction } from '../../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const onSearchByAreaDone: LocationSearchMachineAction<LocationGroups> = assign(
  (_, params) => ({ locations: params }),
);

export const onSearchByGeoDone: LocationSearchMachineAction<LocationGroups> = assign(
  (_, params) => ({
    locations: params,
    predictionLocations: undefined,
    predictions: [],
    predictionsSearchQuery: undefined,
  }),
);

export const setSearchArea: LocationSearchMachineAction = assign(({ event }) => {
  assertEvent(event, 'SET_SEARCH_AREA');

  return { searchArea: event.searchArea };
});

export const setSearchAreaToCurrentPosition: LocationSearchMachineAction = assign(
  ({ context }) => ({
    searchArea: context.currentPosition
      ? getSearchAreaBasedOnCurrentPosition({
          currentPositionCoordinates: context.currentPosition,
          radiusInMiles: 5,
        })
      : undefined,
  }),
);

export const setSelectedSearchArea: LocationSearchMachineAction = assign(({ context }) => ({
  selectedSearchArea: context.searchArea,
}));

export const clearSelectedSearchArea: LocationSearchMachineAction = assign({
  selectedSearchArea: () => undefined,
});

export const clearSearchString: LocationSearchMachineAction = assign({
  searchString: () => '',
});

export const setActiveLocation: LocationSearchMachineAction = assign(({ context, event }) => {
  assertEvent(event, 'NAVIGATE_TO_LOCATION');

  return { activeLocation: getActiveLocation(context, event) };
});

export const clearActiveLocation: LocationSearchMachineAction = assign({
  activeLocation: () => undefined,
});
